import { render, staticRenderFns } from "./AdminVersionTable.vue?vue&type=template&id=6dfc0a23&scoped=true&"
import script from "./AdminVersionTable.vue?vue&type=script&lang=ts&"
export * from "./AdminVersionTable.vue?vue&type=script&lang=ts&"
import style0 from "./AdminVersionTable.vue?vue&type=style&index=0&id=6dfc0a23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfc0a23",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VRow,VSimpleTable})
